import { TablePagination } from '@mui/material';
import createPaginationHook from '../../hooks/createPaginationHook';
import { pageProductsActions, selectLocalSearchResult } from './slice';

const usePagination = createPaginationHook({
  selectResult: selectLocalSearchResult,
  actions: pageProductsActions,
});

const ProductsPagination = () => {
  return (
    <TablePagination
      rowsPerPageOptions={[5, 10, 20]}
      component="div"
      labelRowsPerPage="Số sản phẩm trên trang"
      labelDisplayedRows={({ from, to, count }) => `${from}-${to} / ${count}`}
      {...usePagination()}
    />
  );
};

export default ProductsPagination;
